import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Component, OnInit } from '@angular/core';
import { Router, Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { AuthenticationService } from '../../login/AuthService/auth.service'
import { AppService } from '../../app.service';
import { Observable } from 'rxjs/Observable';
import decode from 'jwt-decode';
declare var $: any;
declare var jQuery: any;

@Component({
  selector: 'menu-left',
  styleUrls: ['menu-left.component.scss'],
  templateUrl: './menu-left-vertical.component.html',
})
export class MenuLeftComponent implements OnInit {

  public _username;
  isLoggedIn: boolean;
  constructor(private http: Http, public auth: AuthenticationService, public router: Router, public apiService: AppService) {
    this.isLoggedIn = false;
  }
  hide() { this.isLoggedIn = false; }
  
  show() { this.isLoggedIn = true; }

  // activate(){
  //   const user = localStorage.getItem('User')
  //   var temp = JSON.parse(user)
  //   const token = temp['token'];
  //   const tokenPayload = decode(token);
  //   var str = tokenPayload.user.role.toLowerCase()
  //   if (str != 'admin') {
  //     return false; 
  //   }
  //   return true;
  // }

  ngOnInit() {
  }

  loadusername() {
    let user = JSON.parse(localStorage.getItem('User'));
    if(user!= null)
    {
    this.apiService.get('account/r/' + user.userid).subscribe(d => {
      this._username = d.display_name;
      if(d.role == 'Server Admin' || d.role == 'Site Administrator')
      {
        this.show();
      }
      else{
        this.hide();        
      }
    });
  }
  else{
    this.logout();
  }
  }
  public get username() {
    if (!this._username) {
      this.loadusername()
    }
    return this._username;
  }

  public get authenticated() {
    return this.auth.isAuth();
  }

  logout() {
    const user = JSON.parse(localStorage.getItem('User'));
    if (user) {
      localStorage.removeItem('User');
      this.router.navigate(['/login']);
      this._username = '';
      this.hide();     

    }

  }
}


// WEBPACK FOOTER //
// ./src/app/home-page/menu-left/menu-left.component.ts